













import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import Button from '@/apps/open/components/Button'
import { APP_TOPIC_MAP } from '@/apps/open/constants'
import { getInceptMsgAdress, setInceptMsgAdress, getAppExtraInfo, setAppTopic } from '@/apps/open/services/app'
import EditInceptMsgAdressForm from '@/apps/open/components/DialogBodys/app/EditInceptMsgAdressForm.vue'
import ViewInceptMsgAdress from '@/apps/open/components/DialogBodys/app/ViewInceptMsgAdress.vue'
import EditMsgType from '@/apps/open/components/DialogBodys/app/EditMsgType.vue'
import { onRequestError } from '@/apps/open/utils'

@Component({
  components: {
    Button
  }
})
export default class InceptMsgAdress extends Vue {
  title = '事件订阅地址'
  inceptMsgAdress = ''
  appExtraInfo:any = {}

  get appId () {
    return this.$route.params.id
  }

  get app () {
    return this.$store.getters['App/appInfo']
  }

  get isSandbox () {
    return this.app.is_sandbox
  }

  get topic () {
    const valueKeys:any = this.appExtraInfo.topic && this.appExtraInfo.topic.split(',')
    const topic:any[] = []
    APP_TOPIC_MAP.forEach((i:any) => {
      let flag = false
      i.keys.forEach((v:any) => {
        if (valueKeys.includes(v)) {
          flag = true
        } else {
          flag = false
        }
      })
      if (flag) {
        topic.push(i.name)
      }
    })
    return topic
  }

  get rules () {
    const rules = [
      { required: true, message: '请输入通知地址' },
      { type: 'url', message: '通知地址格式不正确，请重新输入' }
    ] as any
    if (!this.isSandbox) {
      rules.push({ pattern: /^https:\/\//, message: '通知地址格式不正确，请重新输入' })
    }
    return rules
  }

  showViewDialog () {
    this.$dialog.show({
      title: '接收消息',
      body: ViewInceptMsgAdress,
      bodyProps: {
        value: this.appExtraInfo,
        topic: this.topic,
        submit: this.submitUrl
      },
      buttons: [
        { text: '取消' },
        { text: '修改', type: 'primary', fn: this.showEditDialog }
      ]
    })
  }

  showEditDialog () {
    this.$dialog.show({
      title: `${this.title}配置`,
      body: EditInceptMsgAdressForm,
      bodyProps: {
        value: this.appExtraInfo,
        topicLength: this.topic.length,
        rules: this.rules,
        placeholder: `请输入${this.isSandbox ? '' : 'https://开头的'}地址`,
        submit: this.submitUrl,
        showMsgType: this.showMsgType,
        onCancel: this.$dialog.close
      }
    })
  }

  async submitUrl (url: string) {
    try {
      if (url !== this.inceptMsgAdress) {
        await setInceptMsgAdress(this.appId, url)
        this.$message.success(`${this.title}保存成功`)
        this.load()
      }
    } catch (error) {
      onRequestError(error)
    }
    this.$dialog.close()
  }

  async submitTopic (topic: string) {
    try {
      if (topic) {
        await setAppTopic(this.appId, topic)
        this.$message.success(`添加保存成功`)
        this.load()
      }
    } catch (error) {
      onRequestError(error)
    }
    this.$dialog.close()
  }

  showMsgType () {
    this.$dialog.show({
      title: `添加消息类型`,
      body: EditMsgType,
      bodyProps: {
        value: this.appExtraInfo.topic,
        rules: this.rules,
        placeholder: `请输入${this.isSandbox ? '' : 'https://开头的'}地址`,
        submit: this.submitTopic,
        showMsgType: this.showMsgType,
        onCancel: this.$dialog.close
      }
    })
  }

  async load () {
    try {
      const res = await getAppExtraInfo(this.appId)
      this.inceptMsgAdress = res.data.object.open_msg_notify_url
      this.appExtraInfo = res.data.object
    } catch (error) {
      onRequestError(error)
    }
  }

  mounted () {
    this.load()
  }
}
